import React, { useState, useEffect, useContext } from 'react';
import { graphql } from 'gatsby';
import loadable from '@loadable/component';

import { makeStyles } from '@material-ui/core/styles';
import { Container } from '@material-ui/core';

import { Hero } from '../components/Industry/Hero';
import { SupportedProducts } from '../components/Industry/SupportedProducts';
import { IndustryFAQ } from '../components/Industry/IndustryFAQ';
import { Resources } from '../components/General/Resources';
import { WaveUpSVG } from '../components/WaveSVGs/WaveUpSVG';
import { WaveDownSVG } from '../components/WaveSVGs/WaveDownSVG';
import { FeaturedLogos } from '../components/Industry/IndustryTestimonial/FeaturedLogos';
import { Related } from '../components/Industry/Related';
import { SEO } from '../components/SEO';
import { SoftwareFeatures } from '../components/Industry/SoftwareFeatures';
import { FeatureModal } from '../components/Industry/SoftwareFeatures/FeatureModal';
//import { RmSpecialSoftwareFeatures } from '../components/Industry/SoftwareFeatures';
import { AbridgedSoftwareFeatures } from '../components/Industry/SoftwareFeatures/AbridgedSoftwareFeatures';
import { IndustryBody } from '../components/Industry/IndustryBody';
import { ThumbnailFeatureModal } from '../components/General/ThumbnailFeatureModal';
// import { Form } from '../components/ContactForm/Form';
import FeatureThumbnailContext from '../context/FeatureThumbnailContext';
import { HomeNewsBar } from '../components/Home/HomeBody/HomeNewsBar';
import { HeroModal } from '../components/Home/Hero/HeroModal';
import { HeroVideoEmbed } from '../components/General/HeroVideoEmbed';

const Form = loadable(() => import('../components/ContactForm/Form'));

const useStyles = makeStyles((theme) => ({
  background: {
    background: theme.white,
  },
  relatedBackground: {
    marginBottom: '7rem',
    [theme.breakpoints.down('md')]: {
      marginBottom: '4rem',
    },
  },
  formWaveDown: {
    marginBottom: '-8rem',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '-4rem',
    },
    [theme.breakpoints.down('xs')]: {
      marginBottom: '-3rem',
    },
  },
  formWaveUp: {
    marginBottom: '-8rem',
    [theme.breakpoints.down('sm')]: {
      marginBottom: '-10rem',
    },
  },
  formCont: {
    padding: '10rem 0 24rem',
    [theme.breakpoints.down('md')]: {
      padding: '10rem 0',
    },
    [theme.breakpoints.down('xs')]: {
      padding: '8rem 0',
    },
  },
}));

export default function Industry({
  data: { industry, industryLogos },
  location,
}) {
  const classes = useStyles();
  const iosLogo = industryLogos.edges[0];
  const androidLogo = industryLogos.edges[1];
  const qbLogo = industryLogos.edges[2];
  const zapierLogo = industryLogos.edges[3];
  const shopifyLogo = industryLogos.edges[4];

  const { modalOpen, setModalOpen, selectedThumbnail } = useContext(
    FeatureThumbnailContext
  );

  //state for selected card for features
  const [selectedFeature, setSelectedFeature] = useState(null);

  useEffect(() => {
    setSelectedFeature(industry.featureSection[0]?._key);
  }, []);

  //feature list modal controls
  const [featureModalOpen, setFeatureModalOpen] = useState(false);

  const [heroEmbedModalOpen, setHeroEmbedModalOpen] = useState(false);

  const {
    metaTitle,
    metaDescription,
    marketoId,
    pardotUrl,
    contactForm,
    industryHero,
    newsBar,
    relatedIndustries,
    relatedHeader,
    formBgImage,
    accentColor,
    softwareFeaturesHeader,
    softwareFeaturesSubheader,
    softwareFeatures,
    featuredInLogos,
    featuredInHeader,
    supportedProductsHeader,
    supportedProductsSubheader,
    faq,
    faqTitle,
    resourceTitle,
    resources,
    _rawResourceBody,
    noindex,
    _id,
    videoEmbedHero,
    awardImages = [],
  } = industry;

  const landscapingBusinessLpVariant = _id.includes(
    '04c47ae8-879b-4316-8a68-5097b139d50a'
  );
  return (
    <>
      <SEO title={metaTitle} description={metaDescription} noindex={noindex} />
      {videoEmbedHero ? (
        <HeroVideoEmbed
          hero={videoEmbedHero}
          setHeroModalOpen={setHeroEmbedModalOpen}
        />
      ) : (
        <Hero hero={industryHero} accentColor={accentColor[0]?.hexValue} rg />
      )}

      {newsBar?.newsBarLink && (
        <Container>
          <HomeNewsBar
            background={newsBar.newsBarBackground}
            header={
              newsBar._rawNewsBarBlockHeader
                ? newsBar._rawNewsBarBlockHeader
                : newsBar.newsBarHeader
            }
            newsBarLink={newsBar.newsBarLink}
            newsBarText={newsBar.newsBarText}
            newsBarImage={newsBar.newsBarImage}
            newsBarMobileImage={newsBar.newsBarMobileImage}
            internalLink={newsBar.internalLink}
          />
        </Container>
      )}

      <IndustryBody
        industry={industry}
        iosLogo={iosLogo}
        androidLogo={androidLogo}
        qbLogo={qbLogo}
        zapierLogo={zapierLogo}
        shopifyLogo={shopifyLogo}
        setFeatureModalOpen={setFeatureModalOpen}
        landscapingBusinessLpVariant={landscapingBusinessLpVariant}
        awardImages={awardImages}
      />

      <Container>
        {/* <FeaturedLogos
					featuredInLogos={featuredInLogos}
					featuredHeader={featuredInHeader}
				/> */}

        {/* <SoftwareFeatures
					header={supportedProductsHeader}
					subheader={supportedProductsSubheader}
					softwareFeatures={softwareFeatures}
					accentColor={accentColor[0].hexValue}
				/> */}
        <AbridgedSoftwareFeatures
          header={softwareFeaturesHeader}
          subheader={softwareFeaturesSubheader}
          softwareFeatures={softwareFeatures}
          accentColor={accentColor[0].hexValue}
        />
      </Container>

      {faq.length ? (
        <>
          <WaveDownSVG height='213' width='100%' fill='#FFFFFF' />
          <div style={{ background: '#f4f8ff' }}>
            <Container>
              <IndustryFAQ header={faqTitle} faq={faq} />
            </Container>
          </div>
          <WaveUpSVG height='213' width='100%' fill='#fff' />
        </>
      ) : null}

      {relatedIndustries.length ? (
        <div
          className={classes.relatedBackground}
          style={{ background: '#FFFFFF' }}
        >
          <Container>
            <Related related={relatedIndustries} header={relatedHeader} />
          </Container>
        </div>
      ) : null}

      <div
        className={classes.formCont}
        style={{
          backgroundImage: `url(${formBgImage?.asset?.gatsbyImageData?.images.fallback.src})`,
          backgroundSize: 'cover',
          marginTop: !relatedIndustries.length ? '7rem' : '0',
        }}
      >
        {!!selectedFeature ? (
          <Form
            formId={marketoId}
            pardotUrl={pardotUrl}
            contactForm={contactForm}
            privacy
            modal={false}
            location={location}
          />
        ) : null}
      </div>
      <FeatureModal
        header={supportedProductsHeader}
        subheader={supportedProductsSubheader}
        softwareFeatures={softwareFeatures}
        open={featureModalOpen}
        setFeatureModalOpen={setFeatureModalOpen}
        accentColor={accentColor[0].hexValue}
      />
      <Container>
        <Resources
          header={resourceTitle}
          resources={resources}
          subheader={_rawResourceBody}
        />
      </Container>
      <div>
        <WaveUpSVG height='213' width='100%' fill='#f4f8ff' />
      </div>
      <ThumbnailFeatureModal
        open={modalOpen}
        setFeatureModalOpen={setModalOpen}
        wistiaLink={selectedThumbnail}
        feature
      />
      {videoEmbedHero && (
        <HeroModal
          open={heroEmbedModalOpen}
          setHeroModalOpen={setHeroEmbedModalOpen}
          homeHeroVideo={videoEmbedHero.wistiaLink}
        />
      )}
    </>
  );
}

export const query = graphql`
  query ($slug: String!) {
    industry: sanityIndustries(slug: { current: { eq: $slug } }) {
      _id
      title
      metaTitle
      metaDescription
      noindex
      accentColor {
        hexValue
      }
      industryHero {
        ctaText
        _rawContent
        backgroundImage {
          asset {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
      }
      videoEmbedHero {
        ctaText
        wistiaLink
        wistiaImage {
          asset {
            gatsbyImageData(placeholder: BLURRED, height: 600, width: 380)
          }
        }
        nameAndTitleImage {
          asset {
            gatsbyImageData(placeholder: BLURRED, width: 410)
          }
        }
        backgroundImage {
          asset {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
        _rawContent
      }
      overviewHeader
      _rawOverviewBody
      overviewImage {
        asset {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
      awardImages {
        asset {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
      # industryCallout {
      #   ctaBackground {
      #     asset {
      #       gatsbyImageData(placeholder: BLURRED)
      #     }
      #   }
      #   ctaHeader
      #   ctaSubheader
      #   ctaText
      #   internalLink
      #   ctaLink
      # }
      newsBar {
        newsBarBackground {
          asset {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
        _rawNewsBarBlockHeader
        newsBarHeader
        newsBarImage {
          asset {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
        newsBarMobileImage {
          asset {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
        newsBarLink
        newsBarText
        internalLink
      }
      # multiuseCta {
      #	 _rawCtaHeader
      #	 ctaSubheader
      #	 ctaText
      #	 ctaLink
      #	 internalLink
      #	 ctaBackground {
      #		 asset {
      #			 gatsbyImageData(placeholder: BLURRED)
      #		 }
      #	 }
      #	 mobileCtaBackground {
      #		 asset {
      #			 gatsbyImageData(placeholder: BLURRED)
      #		 }
      #	 }
      # }
      featureHeader
      featureSection {
        _key
        title
        cardTitle
        cardFaIcon
        cardIconColor {
          hexValue
        }
        bodySubHeader
        bodyHeader
        bodySubHeader
        image {
          featureImage {
            asset {
              gatsbyImageData(placeholder: BLURRED)
            }
          }
        }
        videoVariant
        androidLink
        iosLink
        qbLink
        ctaText
        # svgVariant
        thumbnailVideoUrl
        _rawBodyCopy
        navatticPopUp {
          dataNavatticOpen
          dataNavatticTitle
        }
      }
      # rmSpecialFeature {
      # 	title
      # 	bodySubHeader
      # 	bodyHeader
      # 	bodySubHeader
      # 	logoHeader
      # 	image {
      # 		featureImage {
      # 			asset {
      # 				gatsbyImageData(placeholder: BLURRED)
      # 			}
      # 		}
      # 	}
      # 	videoVariant
      # 	ctaText
      # 	_rawBodyCopy
      # }
      softwareFeaturesHeader
      softwareFeaturesSubheader
      # supportedProducts {
      # 	cards {
      # 		title
      # 		cardTopLogo {
      # 			asset {
      # 				gatsbyImageData(placeholder: BLURRED)
      # 			}
      # 		}
      # 		ctaText
      # 		link
      # 		cardBottomImage {
      # 			asset {
      # 				gatsbyImageData
      # 			}
      # 		}
      # 		_rawCardText
      # 	}
      # }
      softwareFeatures {
        _id
        title
        comparisonHeader
        featureListCta
        logos {
          asset {
            gatsbyImageData(placeholder: BLURRED, height: 85)
          }
        }
        # associatedProducts {
        # 	cards {
        # 		title
        # 	}
        # }
        features {
          featureTitle
          featureDescription
          colOne
          colTwo
          colThree
        }
        # ctaLineTitle
        # ctaRows {
        # 	ctaText
        # 	ctaLink
        # }
        expandText
        hideText
        expandedListHeader
        expandedListSubheader
      }
      faqTitle
      faq {
        question
        _rawAnswer
      }
      testimonialTitle
      testimonial {
        title
        header
        testimonialLogo {
          asset {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
        company
        testimonialText
        nameAndTitle
        videoVariant
        image {
          asset {
            gatsbyImageData(
              fit: FILLMAX
              height: 450
              width: 775
              placeholder: BLURRED
            )
          }
        }
      }
      testimonialBackground {
        asset {
          gatsbyImageData(placeholder: BLURRED, height: 800)
        }
      }
      featuredInHeader
      featuredInLogos {
        featuredInLogoTitle
        featuredInLogo {
          asset {
            gatsbyImageData(placeholder: BLURRED, width: 225)
          }
        }
      }
      relatedHeader
      relatedIndustries {
        faIcon
        accentColor {
          hexValue
        }
        title
        slug {
          current
        }
      }
      resourceTitle
      _rawResourceBody
      resources {
        title
        blurb
        image {
          asset {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
        ctaText
        ctaLink
      }
      contactForm {
        header
        privacyPolicy
      }
      formBgImage {
        asset {
          gatsbyImageData(placeholder: BLURRED)
        }
      }
      marketoId
      pardotUrl
      customerLogos {
        logo {
          asset {
            gatsbyImageData(placeholder: BLURRED)
          }
        }
        title
      }
      customerLogosHeader
    }
    industryLogos: allSanityAppLogos {
      edges {
        node {
          appLogoTitle
          appLogo {
            asset {
              gatsbyImageData
            }
          }
        }
      }
    }
  }
`;
